// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { LikedDance } = initSchema(schema);

export {
  LikedDance
};